"use client";

import { c as _c } from "react/compiler-runtime";
import React, { type JSX } from "react";
import type { ApiWave } from "@/generated/models/ApiWave";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import { TabToggleWithOverflow } from "@/components/common/TabToggleWithOverflow";
import WaveHeader from "@/components/waves/header/WaveHeader";
import BrainRightSidebarContent from "./BrainRightSidebarContent";
import BrainRightSidebarFollowers from "./BrainRightSidebarFollowers";
import BrainRightSidebarSettings from "./BrainRightSidebarSettings";
import { Mode, SidebarTab } from "./BrainRightSidebarTypes";
import { WaveLeaderboardRightSidebarVoters } from "@/components/waves/leaderboard/sidebar/WaveLeaderboardRightSidebarVoters";
import { WaveLeaderboardRightSidebarActivityLogs } from "@/components/waves/leaderboard/sidebar/WaveLeaderboardRightSidebarActivityLogs";
interface WaveContentProps {
  readonly wave: ApiWave;
  readonly mode: Mode;
  readonly setMode: (mode: Mode) => void;
  readonly activeTab: SidebarTab;
  readonly setActiveTab: (tab: SidebarTab) => void;
}
interface TabOption {
  key: SidebarTab;
  label: string;
}
export const WaveContent: React.FC<WaveContentProps> = t0 => {
  const $ = _c(37);
  const {
    wave,
    mode,
    setMode,
    activeTab,
    setActiveTab
  } = t0;
  let t1;
  if ($[0] !== mode || $[1] !== setMode) {
    t1 = () => setMode(mode === Mode.FOLLOWERS ? Mode.CONTENT : Mode.FOLLOWERS);
    $[0] = mode;
    $[1] = setMode;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onFollowersClick = t1;
  const isRankWave = wave.wave.type === ApiWaveType.Rank;
  const isApproveWave = wave.wave.type === ApiWaveType.Approve;
  const isCompetitionWave = isRankWave || isApproveWave;
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      key: SidebarTab.ABOUT,
      label: "About"
    };
    t3 = {
      key: SidebarTab.SETTINGS,
      label: "Settings"
    };
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isCompetitionWave) {
    t4 = [t2, t3, ...(isCompetitionWave ? [{
      key: SidebarTab.TOP_VOTERS,
      label: "Voters"
    }, {
      key: SidebarTab.ACTIVITY_LOG,
      label: "Activity"
    }] : [])];
    $[5] = isCompetitionWave;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const options = t4;
  let t5;
  if ($[7] !== onFollowersClick || $[8] !== wave) {
    t5 = <WaveHeader wave={wave} onFollowersClick={onFollowersClick} useRing={false} useRounded={false} />;
    $[7] = onFollowersClick;
    $[8] = wave;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== mode || $[11] !== setMode || $[12] !== wave) {
    t6 = mode === Mode.CONTENT ? <BrainRightSidebarContent wave={wave} /> : <BrainRightSidebarFollowers wave={wave} closeFollowers={() => setMode(Mode.CONTENT)} />;
    $[10] = mode;
    $[11] = setMode;
    $[12] = wave;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = <div className="tw-h-full tw-divide-x-0 tw-divide-y tw-divide-solid tw-divide-iron-700">{t5}{t6}</div>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== wave) {
    t8 = <BrainRightSidebarSettings wave={wave} />;
    $[17] = wave;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== isCompetitionWave || $[20] !== wave) {
    t9 = isCompetitionWave ? {
      [SidebarTab.TOP_VOTERS]: <div className="tw-p-4"><WaveLeaderboardRightSidebarVoters wave={wave} /></div>,
      [SidebarTab.ACTIVITY_LOG]: <div className="tw-p-4"><WaveLeaderboardRightSidebarActivityLogs wave={wave} /></div>
    } : {};
    $[19] = isCompetitionWave;
    $[20] = wave;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t7 || $[23] !== t8 || $[24] !== t9) {
    t10 = {
      [SidebarTab.ABOUT]: t7,
      [SidebarTab.SETTINGS]: t8,
      ...t9
    };
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  const sidebarTabComponents = t10;
  const activeSidebarTab = sidebarTabComponents[activeTab] ? activeTab : SidebarTab.ABOUT;
  const activeSidebarComponent = sidebarTabComponents[activeSidebarTab];
  let t11;
  if ($[26] !== setActiveTab) {
    t11 = key => setActiveTab(key as SidebarTab);
    $[26] = setActiveTab;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== activeSidebarTab || $[29] !== options || $[30] !== t11) {
    t12 = <div className="tw-pb-px tw-pl-2.5"><TabToggleWithOverflow options={options} activeKey={activeSidebarTab} onSelect={t11} maxVisibleTabs={options.length} /></div>;
    $[28] = activeSidebarTab;
    $[29] = options;
    $[30] = t11;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== activeSidebarComponent) {
    t13 = <div>{activeSidebarComponent}</div>;
    $[32] = activeSidebarComponent;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== t12 || $[35] !== t13) {
    t14 = <>{t12}{t13}</>;
    $[34] = t12;
    $[35] = t13;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  return t14;
};